import { jsx as _jsx } from "react/jsx-runtime";
import { Slider } from "@mui/material";
var DateRangeSlider = function (_a) {
    var collection = _a.collection, dateRange = _a.dateRange, setDateRange = _a.setDateRange, disabled = _a.disabled;
    var manifestYears = (collection === null || collection === void 0 ? void 0 : collection.manifests().flatMap(function (manifest) { return manifest.navDateYear(); }).filter(function (v) { return v !== null; })) || [];
    var marks = Array.from(new Set(manifestYears)).map(function (v) { return ({ value: v, label: null }); });
    var lowestYear = Math.min.apply(Math, manifestYears);
    var highestYear = Math.max.apply(Math, manifestYears);
    var handleDateChange = function (event, newValue, activeThumb) {
        if (!Array.isArray(newValue))
            newValue = [newValue, newValue];
        setDateRange(newValue);
    };
    return (_jsx(Slider, { getAriaLabel: function () { return 'Years'; }, value: dateRange, min: lowestYear, max: highestYear, step: 1, sx: { verticalAlign: "middle", width: "40%" }, marks: marks, onChange: handleDateChange, valueLabelDisplay: "auto", getAriaValueText: function (value) { return "" + value; }, disableSwap: true, disabled: disabled }, void 0));
};
export default DateRangeSlider;
